import React from 'react';

import {useDispatch, useSelector} from 'react-redux';

import {setLargeContentWarningVisibility} from 'app/toasts/slice';
import {getContentType} from 'app/utils/content-type';
import {gt} from 'app/utils/i18n';
import {capitalizeFirstLetter} from 'app/utils/strings';

import {DocumentAlertBox} from './DocumentAlertBox';

import type {
  BaseDocumentContentType,
  BaseDocumentVersionContentType,
} from 'sweet-types';

interface Props {
  contentType: BaseDocumentVersionContentType | BaseDocumentContentType;
  id: number;
  isLarge?: boolean;
}
export const LargeContentAlertBox = ({contentType, id, isLarge}: Props) => {
  const dispatch = useDispatch();
  const isHidden = useSelector(
    (state) =>
      state.toasts.hiddenWarnings.largeContent[`${contentType}:${id}`] === true
  );

  const ct = getContentType(contentType);
  const ctSingular = ct.name;
  const ctPlural = ct.pluralName;
  return isHidden || isLarge !== true ? null : (
    <DocumentAlertBox
      type="warning"
      icon="fa-exclamation-triangle"
      title={gt('Large %s Warning', capitalizeFirstLetter(ctSingular))}
      onClose={() =>
        dispatch(
          setLargeContentWarningVisibility({contentType, id, visible: true})
        )
      }
      content={
        <div>
          <p>
            {gt(
              'This %(ctSingular)s is unusually large. Large %(ctPlural)s may load slowly on your device and be too large for SweetAI to work on.',
              {
                ctSingular,
                ctPlural,
              }
            )}
          </p>
          <p>
            {gt('Here are some tips for keeping your %(ctPlural)s trim', {
              ctPlural,
            })}
          </p>
          <ul>
            <li>{gt('Remove extra whitespace at the end of your steps')}</li>
            <li>
              {gt(
                'If you have copied and pasted code or other documents into a step, consider attaching them as a file instead'
              )}
            </li>
            <li>{gt('Contact our support team for further help')}</li>
          </ul>
        </div>
      }
    />
  );
};
